import variables from '../variables'

import type { RadioOverrideToken } from './types'

const Radio: RadioOverrideToken = {
  colorBgContainerDisabled: variables.gray20,
  colorTextDisabled: variables.gray60
} as const

export default Radio
